import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { rejectProspects } from 'api/prospector/prospects';
import { appNotify } from 'store/actions';

const RejectModal = ({
  isOpen,
  classes,
  selectedRows,
  user,
  setIsOpen,
  refreshButtonClick,
  appNotify
}) => {
  const [rejectReason, setRejectReason] = useState('');
  const [rejectLoading, setRejectLoading] = useState(false);

  function handleReject() {
    const rejectedProspects = selectedRows.map(prospect => {
      return (
        {
          prospectId: prospect.id,
          rejectReason: rejectReason,
          rejectedBy: user.id
        }
      )
    });
    setRejectLoading(true);
    rejectProspects(rejectedProspects).then(data => {
      console.log(data)
      if (data.success === 'success') {
        appNotify(data.message, 'success');
        handleClose();
        refreshButtonClick();
      } else {
        appNotify(`Unable to reject property - ${data.message}`, 'warning');
        setRejectLoading(false);
      }
    }).catch(error => {
      console.log(error);
      appNotify(`An error occurred - ${error.message || error}`, 'error');
      setRejectLoading(false);
    });
  }

  const handleInputChange = input => {
    setRejectReason(input);
  }

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setRejectLoading(false);
    setRejectReason('');
    setIsOpen(false);
  }
  return (
    <Dialog
      open={isOpen} 
      onClose={handleClose}
      maxWidth='sm' 
      fullWidth 
    >
      <DialogTitle disableTypography={true} className={classes.dialogTitleRoot}>
        <Typography variant={'h6'}>
          <span>Reject Prospects</span>
        </Typography>
        <Typography variant='body1' >{`${selectedRows.length} prospect${selectedRows.length > 1 ? 's' : ''} selected`}</Typography>
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        <TextField
          className={classes.filterField}
          fullWidth
          type='text'
          size='small'
          variant='outlined'
          value={rejectReason}
          onChange={e => handleInputChange(e.target.value)}
          label='Reject Reason'
        />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>Cancel</Button>
        <Button variant='contained' color='primary' onClick={handleReject} disabled={rejectReason === '' || rejectLoading}>Reject</Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = theme => ({
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  filterField: {
    marginTop: 16
  },
  dialogTitleRoot: {
    paddingBottom: 0
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
  overlay: {
    height: 'calc(100vh - (100vh - 100%) - 48px)',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  }
});

const mapState = state => {
  return {
    user: state.appState.user
  }
};

const mapDispatch = dispatch => {
  return {
    appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
  }
};

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(RejectModal);